import React from 'react';
import cn from 'classnames';
import * as styles from './Loader.module.css';

export function Loader() {
  return (
    <div className={styles.loaderSpinner}>
      <div className={styles.loaderBounce} />
      <div className={cn([styles.loaderBounce, styles.second])} />
    </div>
  );
}
